<div class="SAS_Navbar">
  <!-- Header -->
  <app-outer-pages-header></app-outer-pages-header>

  <div class="intro2">

    <div class="container">
       <div class="my-5">
        <div class="row justfy-center">

          <div class="card border-info" style="width: 20rem;">
            <img class="card-img-top" src="{{doctor.pictureUrl}}" style="max-height: 365px;" alt="Card image cap">
            <div class="card-body">
              <h5 class="card-title text-center">د. {{doctor.firstName}} {{doctor.midName}} {{doctor.lastName}}</h5>
              <p class="card-text"> <span class="text-site-color"> التميز في علاج اضطرابات محددة مثل :  </span> {{doctor.distinguishedIn}}.</p>
            </div>
            <ul class="list-group list-group-flush" style="text-align: right;">
              <li class="list-group-item"> <span class="text-site-color"> التخصص : </span> {{doctor.specialities}}</li>
              <li class="list-group-item">
                <span *ngIf='doctor.scientificDegree=="MSc" '><span class="text-site-color"> الدرجة العلمية : </span> أخصائى </span>
                <span *ngIf='doctor.scientificDegree=="PSc" '><span class="text-site-color"> الدرجة العلمية : </span> أخصائى أول </span>
                <span *ngIf='doctor.scientificDegree=="PhD" '><span class="text-site-color"> الدرجة العلمية : </span> استشارى </span>
              </li>
              <li class="list-group-item"><span class="text-site-color"> الخبرة العلمية : </span> {{doctor.experienceYears}} سنة</li>
              <li class="list-group-item"><span class="text-site-color"> الخدمة المقدمة : </span> {{doctor.serviceProvided}}</li>
            </ul>
          </div>

        </div>
      </div>
    </div>

  </div>

  <!-- Footer -->
  <app-outer-pages-footer></app-outer-pages-footer>

</div>

